<template>
	<v-app>
		<app-header-bar>
			<template v-slot:navigation></template>
		</app-header-bar>

		<v-snackbar-queue :items="$store.getters.snackbars" :timeout="$store.getters.snackbarTimeout" center
						  close-button-icon="mdi-close" top
						  @remove="$store.dispatch('removeSnackbar', $event)"></v-snackbar-queue>

		<v-main>
			<router-view />
		</v-main>
	</v-app>
</template>

<script>

import AppHeaderBar from "@/components/AppHeaderBar";
export default {
	name: 'App',
	components: { AppHeaderBar },
	metaInfo () {
		return {
			title: 'Signatures'
		}
	}
};
</script>

<style lang="scss">
// make vuetify dialogs movable
.v-dialog.v-dialog--active .popup-header, .v-dialog.v-dialog--active .v-card__title {
	cursor: grab;
}

.v-dialog.v-dialog--active .popup-header:active, .v-dialog.v-dialog--active .v-card__title:active {
	cursor: grabbing;
}
//end make vuetify dialogs movable
</style>